import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';


import { InfoDataPage } from './info-data.page';
import {HeaderModule} from "../../../shared/component/common/header/header.module";
import {ButtonModule} from "../../../shared/component/common/button/button.module";
import {LabelModule} from "../../../shared/component/common/label/label.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    IonicModule,
    HeaderModule,
    ButtonModule,
    LabelModule,
  ],
  declarations: [InfoDataPage]
})
export class InfoDataPageModule {}
